import { mapObject, translateObject } from '@huggg/bar-staff';
import { prop } from 'ramda';
import { urls } from '../../config';
import withAxios from '../../utils/with-axios';
import getParams from '../../utils/getParams';
var balancesMap = {
  available: 'available',
  live: 'live',
  total: 'total'
};

/**
 * Format the API balance into a camelCased version.
 * NOTE: Current version doesn't change anything, but in the future, this may
 *       change, so for consistency between other parts of this library, we
 *       pass it through the translator.
 *
 * @param {Object} balances Balance result from API
 */
function formatAllBalances(balances) {
  var penceFactor = 100;
  var translated = translateObject(balancesMap, balances);
  return mapObject(translated, function (value) {
    return value / penceFactor;
  });
}

/**
 * Fetch all wallet balances for the given user ID.
 * NOTE: This method will not handle any errors.
 *
 * balancesReport.allByUserId([ axiosInstance, ] userId).then(data => { ... })
 * balancesReport.allByUserId(userid).then(data => { ... })
 *
 * @param {Object} [$axios=axios] Axios instance
 * @param {String} userId User Id to fetch balances for
 * @throws {Error} If no userId provided
 * @returns {Promise} Unresolved Promise from API
 */
function allByUserId($axios, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!userId) {
    throw new Error('Prop `userId` is required in `balancesReport.allByUserId`');
  }
  var defaultParams = {
    forceRefresh: false
  };
  return $axios.get(urls.apiV2("/report/balances/user/".concat(userId)), {
    params: getParams(options, defaultParams)
  }).then(prop('data')).then(formatAllBalances);
}
export default {
  allByUserId: withAxios(allByUserId)
};